// extracted by mini-css-extract-plugin
export default {"list":"CMNinJiApaMN3Ecli0_C"};